import clsx from "clsx";
import type { ComponentProps, ReactNode } from "react";

import s from "./info-list.module.scss";

export type InfoListProps = ComponentProps<"div"> & {
  className?: string;
  children: ReactNode;
};

export const InfoList = (props: InfoListProps) => {
  const { className, children, ...rest } = props;

  return (
    <div className={clsx(s.root, className)} {...rest}>
      {children}
    </div>
  );
};

InfoList.displayName = "InfoList";
